/* eslint-disable */

import { onChangeShowOnline } from 'views/User/UserPrivacySettingView/UserPrivacySettingHelpers/handleEvents';

var CryptoJS = require('crypto-js');

var location = window.location || { protocol: 'https:' };
var _utils = require('./utils').utils;
var Message = function (type, id) {
  if ((!this) instanceof Message) {
    return new Message(type);
  }

  this._msg = {};
  this.body = {};
  this.set = obj => { };

  if (typeof Message[type] === 'function') {
    Message[type].prototype.setGroup = this.setGroup;
    this._msg = new Message[type](id);
  }
  return this._msg;
};
Message.prototype.setGroup = function (group) {
  this.body.group = group;
};

/*
 * Read Message
 */
Message.read = function (id) {
  this.id = id;
  this.type = 'read';
};

Message.read.prototype.set = function (opt) {
  this.body = {
    ackId: opt.id,
    to: opt.to,
    conversationId: opt.conversationId,
  };
};

/*
 * Delete Message
 */
Message.delete = function (id) {
  this.id = id;
  this.type = 'deleted';
};

Message.delete.prototype.set = function (opt) {
  this.body = {
    deletedId: opt.id,
    to: opt.to,
    isDeleteConversation: opt.isDeleteConversation,
    conversationId: opt.conversationId,
    isDeclineMessage: opt.isDeclineMessage,
    isOpenedMessage: opt.isOpenedMessage,
    isAccepted: opt.isAccepted,
  };
};

/*
 * Update Message
 */
Message.update = function (id) {
  this.id = id;
  this.type = 'updated';
};

Message.update.prototype.set = function (opt) {
  this.body = {
    updatedId: opt.id,
    to: opt.to,
    data: opt.data,
    type: this.type,
  };
};

/*
 * deliver message
 */
Message.delivery = function (id) {
  this.id = id;
  this.type = 'delivery';
};

Message.delivery.prototype.set = function (opt) {
  this.body = {
    bodyId: opt.id,
    to: opt.to,
  };
};

Message.fastenTxtEdit = function (id) {
  this.id = id;
  this.type = 'fastenTxtEdit';
};

Message.fastenTxtEdit.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    storeMessageByTigase: opt.storeMessageByTigase,
    type: this.type,
    ext: opt.ext || {},
  };
};

/*
 * text message
 */
Message.txt = function (id) {
  this.id = id;
  this.type = 'txt';
  this.body = {};
};
/*
 * Chat States
 */
Message.chatState = function (id) {
  this.id = id;
  this.type = 'chatState';
};

Message.chatState.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
  };
};

Message.txt.prototype.set = function (opt) {
  // this.value = opt.msg; //@@@@@khanhduong update
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    // , msg: this.value  //@@@@@khanhduong update
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    notificationType: opt.notificationType,
    data: this.value,
    type: this.type,
    roomType: opt.roomType,
    ext: opt.ext || {},
    success: opt.success,
    fail: opt.fail,
    isPrivate: opt.isPrivate || false,
    isModerator: opt.isModerator || false,
    storeMessageByTigase: opt.storeMessageByTigase || false,
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };
  !opt.roomType && delete this.body.roomType;
  !opt.senderMemberLevel && delete this.body.senderMemberLevel;
  !opt.recvMemberLevel && delete this.body.recvMemberLevel;
  !opt.isRecvMatching && delete this.body.isRecvMatching;
  !opt.isSenderMatching && delete this.body.isSenderMatching;
  !opt.notificationType && delete this.body.notificationType;
};

/*
 * gallery message //@@@@@khanhduong add new
 */
Message.gallery = function (id) {
  this.id = id;
  this.type = 'gallery';
  this.body = {};
};
Message.gallery.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    roomType: opt.roomType,
    ext: opt.ext || {},
    success: opt.success,
    fail: opt.fail,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    profilePhotoComment: opt.profilePhotoComment,
    time: opt.time,
    expts: opt.expts || 0
  };

  !opt.roomType && delete this.body.roomType;
};

Message.gif = function (id) {
  this.id = id;
  this.type = 'gif';
  this.body = {};
};

Message.gif.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    data: this.value,
    type: this.type,
    roomType: opt.roomType,
    ext: opt.ext || {},
    success: opt.success,
    fail: opt.fail,
    isPrivate: opt.isPrivate || false,
    isModerator: opt.isModerator || false,
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };
  !opt.isPrivate && delete this.body.isPrivate;
  !opt.senderMemberLevel && delete this.body.senderMemberLevel;
  !opt.recvMemberLevel && delete this.body.recvMemberLevel;
  !opt.isRecvMatching && delete this.body.isRecvMatching;
  !opt.isSenderMatching && delete this.body.isSenderMatching;
  !opt.isModerator && delete this.body.isModerator;
  !opt.roomType && delete this.body.roomType;
};

Message.gift = function (id) {
  this.id = id;
  this.type = 'gift';
  this.body = {};
};

Message.gift.prototype.set = function (opt) {
  // this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    success: opt.success,
    fail: opt.fail,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
  };
};

/*
 * command message
 */
Message.cmd = function (id) {
  this.id = id;
  this.type = 'cmd';
  this.body = {};
};
Message.cmd.prototype.set = function (opt) {
  this.value = '';

  this.body = {
    to: opt.to,
    action: opt.action,
    msg: this.value,
    type: this.type,
    roomType: opt.roomType,
    ext: opt.ext || {},
    success: opt.success,
  };
  !opt.roomType && delete this.body.roomType;
};

/*
 * location message
 */
Message.location = function (id) {
  this.id = id;
  this.type = 'loc';
  this.body = {};
};
Message.location.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    type: this.type,
    roomType: opt.roomType,
    addr: opt.addr,
    lat: opt.lat,
    lng: opt.lng,
    ext: opt.ext || {},
  };
};

/*
 * image message
 */
Message.img = function (id) {
  this.id = id;
  this.type = 'img';
  this.body = {};
};

Message.img.prototype.set = function (opt) {
  opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);

  this.value = opt.file;

  this.body = {
    isGroup: opt.isGroup || false,
    id: this.id,
    file: this.value,
    apiUrl: opt.apiUrl,
    endPoint: opt.endPoint,
    to: opt.to,
    type: this.type,
    ext: opt.ext || {},
    roomType: opt.roomType,
    onFileUploadError: opt.onFileUploadError,
    onFileUploadComplete: opt.onFileUploadComplete,
    onFileUploadProgress: opt.onFileUploadProgress, //@@@@@khanhduong add
    success: opt.success,
    fail: opt.fail,
    flashUpload: opt.flashUpload,
    width: opt.width,
    height: opt.height,
    body: opt.body,
    uploadError: opt.uploadError,
    uploadComplete: opt.uploadComplete,
    accessToken: opt.accessToken,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    expts: opt.expts,
    createdAt: opt.createdAt || new Date(),
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };

  !opt.roomType && delete this.body.roomType;
  !opt.senderMemberLevel && delete this.body.senderMemberLevel;
  !opt.recvMemberLevel && delete this.body.recvMemberLevel;
  !opt.isRecvMatching && delete this.body.isRecvMatching;
  !opt.isSenderMatching && delete this.body.isSenderMatching;
};

/*
 * image message
 */
Message.videoFile = function (id) {
  this.id = id;
  this.type = 'videoFile';
  this.body = {};
};

Message.videoFile.prototype.set = function (opt) {
  opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);

  this.value = opt.file;

  this.body = {
    isGroup: opt.isGroup || false,
    id: this.id,
    file: this.value,
    apiUrl: opt.apiUrl,
    endPoint: opt.endPoint,
    to: opt.to,
    type: this.type,
    ext: opt.ext || {},
    roomType: opt.roomType,
    onFileUploadError: opt.onFileUploadError,
    onFileUploadComplete: opt.onFileUploadComplete,
    compress: opt.compress,
    onFileUploadProgress: opt.onFileUploadProgress, //@@@@@khanhduong add
    success: opt.success,
    fail: opt.fail,
    flashUpload: opt.flashUpload,
    width: opt.width,
    height: opt.height,
    body: opt.body,
    uploadError: opt.uploadError,
    uploadComplete: opt.uploadComplete,
    accessToken: opt.accessToken,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    expts: opt.expts,
    createdAt: opt.createdAt || new Date(),
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };

  !opt.roomType && delete this.body.roomType;
  !opt.senderMemberLevel && delete this.body.senderMemberLevel;
  !opt.recvMemberLevel && delete this.body.recvMemberLevel;
  !opt.isRecvMatching && delete this.body.isRecvMatching;
  !opt.isSenderMatching && delete this.body.isSenderMatching;
};

// Audio file
Message.audioFile = function (id) {
  this.id = id;
  this.type = 'audioFile';
  this.body = {};
};

Message.audioFile.prototype.set = function (opt) {
  opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);

  this.value = opt.file;

  this.body = {
    isGroup: opt.isGroup || false,
    id: this.id,
    file: this.value,
    apiUrl: opt.apiUrl,
    endPoint: opt.endPoint,
    to: opt.to,
    type: this.type,
    ext: opt.ext || {},
    roomType: opt.roomType,
    onFileUploadError: opt.onFileUploadError,
    onFileUploadComplete: opt.onFileUploadComplete,
    compress: opt.compress,
    onFileUploadProgress: opt.onFileUploadProgress,
    success: opt.success,
    fail: opt.fail,
    flashUpload: opt.flashUpload,
    body: opt.body,
    uploadError: opt.uploadError,
    uploadComplete: opt.uploadComplete,
    accessToken: opt.accessToken,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    expts: opt.expts,
    createdAt: opt.createdAt || new Date(),
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
    duration: opt.duration,
  };

  !opt.roomType && delete this.body.roomType;
  !opt.senderMemberLevel && delete this.body.senderMemberLevel;
  !opt.recvMemberLevel && delete this.body.recvMemberLevel;
  !opt.isRecvMatching && delete this.body.isRecvMatching;
  !opt.isSenderMatching && delete this.body.isSenderMatching;
};

/*
 * audio message
 */
Message.audio = function (id) {
  this.id = id;
  this.type = 'audio';
  this.body = {};
};
Message.audio.prototype.set = function (opt) {
  opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);

  this.value = opt.file;
  this.filename = opt.filename || this.value.filename;

  this.body = {
    id: this.id,
    file: this.value,
    filename: this.filename,
    apiUrl: opt.apiUrl,
    to: opt.to,
    type: this.type,
    ext: opt.ext || {},
    length: opt.length || 0,
    roomType: opt.roomType,
    file_length: opt.file_length,
    onFileUploadError: opt.onFileUploadError,
    onFileUploadComplete: opt.onFileUploadComplete,
    success: opt.success,
    fail: opt.fail,
    flashUpload: opt.flashUpload,
    body: opt.body,
  };
  !opt.roomType && delete this.body.roomType;
};

/*
 * file message
 */
Message.file = function (id) {
  this.id = id;
  this.type = 'file';
  this.body = {};
};
Message.file.prototype.set = function (opt) {
  opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);

  this.value = opt.file;
  this.filename = opt.filename || this.value.filename;

  this.body = {
    id: this.id,
    file: this.value,
    filename: this.filename,
    apiUrl: opt.apiUrl,
    to: opt.to,
    type: this.type,
    ext: opt.ext || {},
    roomType: opt.roomType,
    onFileUploadError: opt.onFileUploadError,
    onFileUploadComplete: opt.onFileUploadComplete, //@@@@@khanhduong add
    success: opt.success,
    fail: opt.fail,
    flashUpload: opt.flashUpload,
    body: opt.body,
  };
  !opt.roomType && delete this.body.roomType;
};
/*
 * video message
 */
Message.video = function (id) {
  this.id = id;
  this.type = 'video';
  this.body = {};
};
Message.video.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    requestType: opt.requestType,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
  };
};
/*
 * liveStream message
 */
Message.liveStream = function (id) {
  this.id = id;
  this.type = 'liveStream';
  this.body = {};
};
Message.liveStream.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
  };
};
/*
 * banned user from groupchat message
 */
Message.banned = function (id) {
  this.id = id;
  this.type = 'banned';
  this.body = {};
};
Message.banned.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
  };
};
/*
 * block user from groupchat message
 */
Message.blocked = function (id) {
  this.id = id;
  this.type = 'blocked';
  this.body = {};
};
Message.blocked.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
  };
};
/*
 * whisper status user from groupchat message
 */
Message.whisper = function (id) {
  this.id = id;
  this.type = 'whisper';
  this.body = {};
};
Message.whisper.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
  };
};
/*
 * heart message
 */
Message.heartMsg = function (id) {
  this.id = id;
  this.type = 'heartMsg';
  this.body = {};
};
Message.heartMsg.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
  };
};

/*
 * reactions message
 */
Message.reactions = function (id) {
  this.id = id;
  this.type = 'reactions';
  this.body = {};
};

Message.reactions.prototype.set = function (opt) {
  this.value = opt.data;
  this.body = {
    id: this.id,
    to: opt.to,
    data: this.value,
    type: this.type,
    ext: opt.ext || {},
    reactOnMsgId: opt.reactOnMsgId || '',
    group: opt.group || false,
    isDeleteReaction: opt.isDeleteReaction || false,
    time: opt.time,
  };
};

Message.shareLocation = function (id) {
  this.id = id;
  this.type = 'shareLocation';
  this.body = {};
};
Message.shareLocation.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };
};

Message.shareEvent = function (id) {
  this.id = id;
  this.type = 'shareEvent';
  this.body = {};
};
Message.shareEvent.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };
};

Message.shareEventTicket = function (id) {
  this.id = id;
  this.type = 'shareEventTicket';
  this.body = {};
};
Message.shareEventTicket.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };
};

Message.shareDate = function (id) {
  this.id = id;
  this.type = 'shareDate';
  this.body = {};
};
Message.shareDate.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
    profilePhotoComment: opt.profilePhotoComment,
  };
};

Message.screenshot = function (id) {
  this.id = id;
  this.type = 'screenshot';
  this.body = {};
};
Message.screenshot.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
  };
};

Message.quote = function (id) {
  this.id = id;
  this.type = 'quote';
  this.body = {};
};

Message.quote.prototype.set = function (opt) {
  this.value = opt.data;

  this.body = {
    id: this.id,
    to: opt.to,
    body: opt.data,
    data: this.value ? this.value.data : '',
    type: this.value ? this.value.type : '',
    ext: opt.ext || {},
    reactOnMsgId: opt.reactOnMsgId || '',
    messageQuoted: opt.messageQuoted || '',
    group: opt.group || false,
    reactOnMsgUserId: opt.reactOnMsgUserId,
    reactOnMsgUsername: opt.reactOnMsgUsername,
    expts: opt.expts || 0,
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    duration: opt.duration || 0,
    time: opt.time,
  };
  if (opt.file || opt.fileInputId) {
    opt.file = opt.file || _utils.getFileUrl(opt.fileInputId);
    this.value = opt.file;
    this.body = {
      ...this.body,
      type: opt.type,
      endPoint: opt.endPoint,
      isGroup: opt.isGroup || false,
      file: this.value,
      apiUrl: opt.apiUrl,
      roomType: opt.roomType,
      onFileUploadError: opt.onFileUploadError,
      onFileUploadComplete: opt.onFileUploadComplete,
      compress: opt.compress,
      onFileUploadProgress: opt.onFileUploadProgress,
      success: opt.success,
      fail: opt.fail,
      flashUpload: opt.flashUpload,
      width: opt.width,
      height: opt.height,
      body: opt.body,
      uploadError: opt.uploadError,
      uploadComplete: opt.uploadComplete,
      accessToken: opt.accessToken,
      senderMemberLevel: opt.senderMemberLevel,
      recvMemberLevel: opt.recvMemberLevel,
      isRecvMatching: opt.isRecvMatching,
      isSenderMatching: opt.isSenderMatching,
      expts: opt.expts,
      createdAt: opt.createdAt || new Date(),
    };
  }
};

/*
 * Delete message using fasten
 * @param id
 */
Message.fastenDelete = function (id) {
  this.id = id;
  this.type = 'fastenDelete';
};

Message.fastenDelete.prototype.set = function (opt) {
  this.value = opt;
  this.body = {
    deletedId: opt.id,
    to: opt.to,
    type: 'fastenDelete',
  };
};

Message.joinGroupChat = function (id) {
  this.id = id;
  this.type = 'joinGroupChat';
  this.body = {};
};
Message.joinGroupChat.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    time: opt.time,
  };
};

Message.leaveGroupChat = function (id) {
  this.id = id;
  this.type = 'leaveGroupChat';
  this.body = {};
};
Message.leaveGroupChat.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    time: opt.time,
  };
};

Message.removedFromGroup = function (id) {
  this.id = id;
  this.type = 'removedFromGroup';
  this.body = {};
};
Message.removedFromGroup.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    time: opt.time,
  };
};

Message.inviteGroupChat = function (id) {
  this.id = id;
  this.type = 'inviteGroupChat';
  this.body = {};
};
Message.inviteGroupChat.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
    expts: opt.expts || 0,
  };
};

Message.inviteGroup = function (id) {
  this.id = id;
  this.type = 'inviteGroup';
  this.body = {};
};
Message.inviteGroup.prototype.set = function (opt) {
  this.body = {
    to: opt.to,
    id: this.id,
    data: opt.data,
    type: this.type,
    ext: opt.ext || {},
    senderMemberLevel: opt.senderMemberLevel,
    recvMemberLevel: opt.recvMemberLevel,
    isRecvMatching: opt.isRecvMatching,
    isSenderMatching: opt.isSenderMatching,
    time: opt.time,
    expts: opt.expts || 0,
  };
};

var _Message = function (message) {
  if ((!this) instanceof _Message) {
    return new _Message(message, conn);
  }

  this.msg = message;
};

_Message.prototype.send = function (conn) {
  var me = this;
  var _send = function (message) {
    message.ext = message.ext || {};
    message.ext.weichat = message.ext.weichat || {};
    message.ext.weichat.originType = message.ext.weichat.originType || 'webim';
    var dom;
    var json = {
      from: conn.context.userId || '',
      to: message.to,
      bodies: [message.body],
      ext: message.ext || {},
    };
    var jsonstr = _utils.stringify(json);
    dom = $msg({
      type: message.group || 'chat',
      to: message.toJid,
      id: message.id,
      xmlns: 'jabber:client',
    })
      .c('body')
      .t(jsonstr)
      .up()
      .c('custom', {
        xmlns: 'rhp:urn:example:custom',
        expts: message.expts || 0,
        'non-archived': !message.storeMessageByTigase,
      });
    if (message.roomType) {
      dom.up().c('roomtype', { xmlns: 'easemob:x:roomtype', type: 'chatroom' });
    }
    if (message.isPrivate) {
      let json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
        type: 'private-msg',
        isModerator: message.isModerator,
      };
      let jsonstr = _utils.stringify(json);
      dom = $msg({
        type: 'chat',
        from: conn.context.userId,
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(jsonstr);
      dom.up().c('x', { xmlns: 'http://jabber.org/protocol/muc#user' });
    }
    if (message.bodyId) {
      dom = $msg({
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(message.bodyId);
      var delivery = {
        xmlns: 'urn:xmpp:receipts',
        id: message.bodyId,
      };
      dom.up().c('delivery', delivery);
    }
    if (message.ackId) {
      dom = $msg({
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      });
      var read = {
        xmlns: 'urn:xmpp:receipts',
        id: message.ackId,
        conversationId: message.conversationId,
      };
      dom.c('acked', read);
    }
    // delete message
    if (message.deletedId) {
      //debug@-message add new type
      dom = $msg({
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
        type: 'chat',
      });
      var deleted = {
        xmlns: 'urn:xmpp:receipts',
        id: message.deletedId,
        isDeleteConversation: message.isDeleteConversation || 'false',
        from: conn.context.userId || '',
        conversationId: message.conversationId,
        isDeclineMessage: message.isDeclineMessage,
        isOpenedMessage: message.isOpenedMessage,
        isAccepted: message.isAccepted,
      };
      dom.c('deleted', deleted);
    }

    if (message.body.type === 'chatState') {
      let fromJid = conn.context.jid || '';
      dom = $msg({
        from: fromJid,
        id: message.id,
        to: message.toJid,
        type: 'chat',
      }).c(message.data, {
        xmlns: 'http://jabber.org/protocol/chatstates',
      });
      dom.up().c('private', { xmlns: 'urn:xmpp:carbons:2' });
      dom.up().c('no-copy', { xmlns: 'urn:xmpp:hints' });
    }

    if (message.body.type === 'updated') {
      dom = $msg({
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(message.updatedId);
      let jsonTemp = {
        from: conn.context.userId || '',
        to: message.to,
        body: message.body,
        ext: message.ext || {},
      };
      let jsonstrTemp = _utils.stringify(jsonTemp);

      var updated = {
        xmlns: 'urn:xmpp:receipts',
        id: message.id,
        body: jsonstrTemp,
      };
      dom.up().c('updated', updated);
    }

    if (message.body.type === 'video') {
      if (message.requestType === 'end' && message.data !== '') {
        var json = {
          from: conn.context.userId || '',
          to: message.to,
          bodies: [message.body],
          ext: message.ext || {},
        };
        var jsonstr = _utils.stringify(json);
        dom = $msg({
          type: 'chat', // Type 'chat' to support send by message chat
          senderMemberLevel: message.senderMemberLevel,
          recvMemberLevel: message.recvMemberLevel,
          isRecvMatching: message.isRecvMatching,
          isSenderMatching: message.isSenderMatching,
          requestType: message.requestType,
          fromxmppId: conn.context.userId || '',
          toxmppId: message.to,
          id: message.id,
          to: message.toJid,
          data: JSON.stringify(message.data),
        })
          .c('body')
          .t(jsonstr)
          .up()
          .c('custom', {
            xmlns: 'rhp:urn:example:custom',
            expts: message.expts || 0,
            'non-archived': true,
          });
      } else {
        let fromJid = conn.context.jid || '';
        var json = {
          from: conn.context.userId || '',
          to: message.to,
          bodies: [message.body],
          ext: message.ext || {},
        };
        var jsonstr = _utils.stringify(json);
        dom = $msg({
          from: fromJid,
          id: message.id,
          to: message.toJid,
          requestType: message.requestType,
          type: 'video',
          fromxmppId: conn.context.userId || '',
          toxmppId: message.to,
          data: JSON.stringify(message.data),
        })
          .c('body')
          .t(jsonstr)
          .up()
          .c('custom', {
            xmlns: 'rhp:urn:example:custom',
            expts: message.expts || 0,
            'non-archived': true,
          });
        if (conn.enableAdvancedMessageProcessing)
          dom.up().c('amp', { xmlns: 'http://jabber.org/protocol/amp' }).c('rule', {
            action: 'drop',
            condition: 'deliver',
            value: 'stored',
          });
      }
    }

    if (message.body.type === 'reactions') {
      const applyTo = {
        xmlns: 'urn:xmpp:fasten:0',
        id: message.reactOnMsgId,
      };

      if (message.isDeleteReaction) {
        applyTo.clear = 'true';
      }

      const jsonstr = _utils.stringify({
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      });

      dom = $msg({
        type: message.group ? 'groupchat' : 'chat',
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(jsonstr) // add body to resolve issue read data in BE
        .up()
        .c('apply-to', applyTo)
        .c('reaction', { xmlns: 'rhp:urn:xmpp:reaction' })
        .t(message.data)
        .up()
        .up()
        .c('custom', {
          xmlns: 'rhp:urn:example:custom',
          expts: message.expts || 0,
          'non-archived': true,
        });
    }

    if (message.body.type === 'liveStream') {
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      var jsonstr = _utils.stringify(json);
      dom = $msg({
        type: 'groupchat',
        fromxmppId: conn.context.userId || '',
        toxmppId: message.to,
        id: message.id,
        to: message.to,
        data: JSON.stringify(message.data),
      })
        .c('body')
        .t(jsonstr)
        .c('liveStream');
    }

    if (message.body.type === 'banned') {
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      var jsonstr = _utils.stringify(json);
      dom = $msg({
        type: 'groupchat',
        fromxmppId: conn.context.userId || '',
        toxmppId: message.to,
        id: message.id,
        to: message.to,
        data: JSON.stringify(message.data),
      })
        .c('body')
        .t(jsonstr)
        .c('banned');
      // dom = $msg({
      //   type: 'groupchat'
      //   , fromxmppId: conn.context.userId || ''
      //   , toxmppId: message.to
      //   , id: message.id
      //   , to: message.to
      //   , data: JSON.stringify(message.data)
      // }).c('banned');
    }

    if (message.body.type === 'blocked') {
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      var jsonstr = _utils.stringify(json);
      dom = $msg({
        type: 'groupchat',
        fromxmppId: conn.context.userId || '',
        toxmppId: message.to,
        id: message.id,
        to: message.to,
        data: JSON.stringify(message.data),
      })
        .c('body')
        .t(jsonstr)
        .c('blocked');
      // dom = $msg({
      //   type: 'groupchat'
      //   , fromxmppId: conn.context.userId || ''
      //   , toxmppId: message.to
      //   , id: message.id
      //   , to: message.to
      //   , data: JSON.stringify(message.data)
      // }).c('banned');
    }

    if (message.body.type === 'whisper') {
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      var jsonstr = _utils.stringify(json);
      dom = $msg({
        type: 'groupchat',
        fromxmppId: conn.context.userId || '',
        toxmppId: message.to,
        id: message.id,
        to: message.to,
        data: JSON.stringify(message.data),
      })
        .c('body')
        .t(jsonstr)
        .c('whisper');
      // dom = $msg({
      //   type: 'groupchat'
      //   , fromxmppId: conn.context.userId || ''
      //   , toxmppId: message.to
      //   , id: message.id
      //   , to: message.to
      //   , data: JSON.stringify(message.data)
      // }).c('whisper');
    }

    if (message.body.type === 'heartMsg') {
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      var jsonstr = _utils.stringify(json);
      dom = $msg({
        type: 'groupchat',
        fromxmppId: conn.context.userId || '',
        toxmppId: message.to,
        id: message.id,
        to: message.to,
        data: JSON.stringify(message.data),
      })
        .c('body')
        .t(jsonstr)
        .c('heartMsg');
    }
    if (message.body.type === 'img') {
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
        expts: message.expts || 0,
      };
      var jsonstr = _utils.stringify(json);
      dom = $msg({
        type: message.group || 'chat',
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(jsonstr)
        .up()
        .c('custom', {
          xmlns: 'rhp:urn:example:custom',
          expts: message.expts || 0,
          'non-archived': true,
        });
    }

    if (message.body.type === 'gift') {
      const json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      const jsonstr = _utils.stringify(json);
      const custom = {
        xmlns: 'rhp:urn:example:custom',
        msgType: 'gift',
        giftLevel: message.body?.data?.level || 1,
        expts: message.expts || 0,
        giftValue: message.body?.data?.price,
        'non-archived': true,
      };

      dom = $msg({
        type: message.group || 'chat',
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(jsonstr)
        .up()
        .c('custom', custom);
    }

    if (message.body.type === 'fastenDelete') {
      // var json = {
      //   from: conn.context.userId || '',
      //   to: message.to,
      //   bodies: [message.body],
      //   ext: message.ext || {},
      // };
      // var jsonstr = _utils.stringify(json);

      const applyTo = {
        xmlns: 'urn:xmpp:fasten:0',
        id: message.deletedId,
        clear: 'true',
      };
      dom = $msg({
        type: message.group ? 'groupchat' : 'chat',
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        // .c('body')
        // .t(jsonstr)
        // .up()
        .c('apply-to', applyTo)
        .c('retract', { xmlns: 'urn:xmpp:message-retract:' });
    }

    if (message.body.type === 'fastenTxtEdit') {
      const json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      const jsonstr = _utils.stringify(json);

      const applyTo = {
        xmlns: 'urn:xmpp:fasten:0',
        id: message.id,
      };
      dom = $msg({
        type: message.group ? 'groupchat' : 'chat',
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('apply-to', applyTo)
        .c('edit', { xmlns: 'urn:example.edit' })
        .up()
        .c('external', { name: 'body' })
        .up()
        .up()
        .c('body')
        .t(jsonstr)
        .up()
        .c('custom', { xmlns: 'rhp:urn:example:custom', 'non-archived': true })
        .t(message.body.data);
    }

    if (message.messageQuoted && message.messageQuoted.data) {
      // console.log("message", message);
      var json = {
        from: conn.context.userId || '',
        to: message.to,
        bodies: [message.body],
        ext: message.ext || {},
      };
      var jsonstr = _utils.stringify(json);
      const applyTo = {
        xmlns: 'urn:xmpp:fasten:0',
        id: message.reactOnMsgId,
        userId: message.reactOnMsgUserId,
        username: message.reactOnMsgUsername,
      };

      const custom = {
        xmlns: 'rhp:urn:example:custom',
        type: message.messageQuoted.type,
        expts: message.expts || 0,
        'non-archived': true,
      };
      if (message.messageQuoted.exptsTime) {
        custom.refMsgExpTs = message.messageQuoted.exptsTime;
      }
      if (message.messageQuoted.galleryName) {
        custom.refMsgTitle = message.messageQuoted.galleryName;
      }

      dom = $msg({
        type: message.group ? 'groupchat' : 'chat',
        to: message.toJid,
        id: message.id,
        xmlns: 'jabber:client',
      })
        .c('body')
        .t(jsonstr)
        .up()
        .c('apply-to', applyTo)
        .c('external', { name: 'body' })
        .up()
        .c('quote', { xmlns: 'rhp:urn:xmpp:quote' })
        .up()
        .up()
        .c('custom', custom)
        .t(message.messageQuoted.data);
    }

    setTimeout(function () {
      if (typeof _msgHash !== 'undefined' && _msgHash[message.id]) {
        _msgHash[message.id].msg.fail instanceof Function && _msgHash[message.id].msg.fail(message.id);
      }
    }, 60000);
    // console.log('debug@-message._send', dom.tree());
    conn.sendCommand(dom.tree(), message.id);
  };
  if (me.msg.file) {
    if (me.msg.body && me.msg.body.noUpload) {
      // remove un-used field when send in WS
      delete me.msg.body.noUpload;
      me.msg.body.time = me.msg.time;
      // Only send msg
      _send(me.msg);
      return;
    }
    var _tmpComplete = me.msg.onFileUploadComplete;
    var _complete = function (data) {
      console.log("data", data)
      //@@@@@khanhduong update, new API don't have this format
      // if (data.entities[0]['file-metadata']) {
      //   var file_len = data.entities[0]['file-metadata']['content-length'];
      //   // me.msg.file_length = file_len;
      //   me.msg.filetype = data.entities[0]['file-metadata']['content-type'];
      //   if (file_len > 204800) {
      //     me.msg.thumbnail = true;
      //   }
      // }
      if (data && data.length > 0) {
        me.msg.body = {
          type: me.msg.type || 'file',
          // url: ((location.protocol != 'https:' && conn.isHttpDNS) ? (conn.apiUrl + data.uri.substr(data.uri.indexOf("/", 9))) : data.uri) + '/' + data.entities[0]['uuid'] //@@@@@khanhduong update
          data: data && data.length > 0 && data[0].FullUrl, //((location.protocol !== 'https:' && conn.isHttpDNS) ? (conn.apiUrl + data.uri.substr(data.uri.indexOf("/", 9))) : data.uri) + '/' + data.entities[0]['uuid']  //@@@@@khanhduong update
          secret: '', //data.entities[0]['share-secret']  //@@@@@khanhduong update
          filename: me.msg.file.filename || me.msg.file.fileName || me.msg.filename,
          size: {
            width: me.msg.width || me.msg.ext.width || 0,
            height: me.msg.height || me.msg.ext.height || 0,
          },
          length: me.msg.length || 0,
          file_length: me.msg.ext.file_length || 0,
          filetype: me.msg.filetype || me.msg.ext.filetype || me.msg.fileType,
          senderMemberLevel: me.msg.senderMemberLevel,
          recvMemberLevel: me.msg.recvMemberLevel,
          isRecvMatching: me.msg.isRecvMatching,
          isSenderMatching: me.msg.isSenderMatching,
          expts: me.msg.expts || 0,
          createdAt: me.msg.createdAt || new Date(),
          reactOnMsgId: me.msg.reactOnMsgId,
          reactOnMsgUserId: me.msg.reactOnMsgUserId,
          messageQuoted: me.msg.messageQuoted,
          time: me.msg.time,
          profilePhotoComment: me.msg.profilePhotoComment,
        };
        if (me.msg.type === 'videoFile') {
          const rawVideo = data[0].Video;
          me.msg.body.data = {
            ...{
              videoId: rawVideo?.VideoID || 0,
              thumbUrl: rawVideo?.ThumbUrl || '',
              duration: rawVideo?.Duration || 0,
              ownerUserId: conn.context.userId || '',
            },
          };
          if (!me.msg.body.data.videoId) {
            me.msg.onFileUploadError?.(`response data is invalid: ${JSON.stringify(data)}`);
            return;
          }
        } else if (me.msg.type === 'img') {
          if (!me.msg.body.data) {
            me.msg.onFileUploadError?.(`response data is invalid: ${JSON.stringify(data)}`);
            return;
          }
        }
        _send(me.msg);
        _tmpComplete instanceof Function && _tmpComplete(data, me.msg.id);
      } else if (data && data.Result) {
        const bodyData = {
          fileName: data.Result,
          duration: me.msg.duration || 0,
          ownerUserId: conn.context.userId || '',
        };
        if (me.msg.type === 'audioFile') {
          me.msg.body = {
            type: 'audioFile',
            data: bodyData,
            filetype: me.msg.type,
            senderMemberLevel: me.msg.senderMemberLevel,
            recvMemberLevel: me.msg.recvMemberLevel,
            isRecvMatching: me.msg.isRecvMatching,
            isSenderMatching: me.msg.isSenderMatching,
            expts: me.msg.expts || 0,
            createdAt: me.msg.createdAt || new Date(),
            reactOnMsgId: me.msg.reactOnMsgId,
            reactOnMsgUserId: me.msg.reactOnMsgUserId,
            messageQuoted: me.msg.messageQuoted,
            time: me.msg.time,
            profilePhotoComment: me.msg.profilePhotoComment,
          }
        }
        _tmpComplete instanceof Function && _tmpComplete(bodyData, me.msg.id);
        _send(me.msg);
      } else {
        me.msg.onFileUploadError?.(`response data is invalid: ${JSON.stringify(data)}`);
      }
    };
    me.msg.onFileUploadComplete = _complete;
    if (me.msg.type === 'videoFile') _utils.uploadFileNew.call(conn, me.msg);
    else _utils.uploadFile.call(conn, me.msg);
  } else {
    me.msg.body = {
      type: me.msg.type === 'chat' ? 'txt' : me.msg.type,
      // , msg: me.msg.msg  //@@@@@khanhduong update
      data: me.msg.data,
      senderMemberLevel: me.msg.senderMemberLevel,
      recvMemberLevel: me.msg.recvMemberLevel,
      isRecvMatching: me.msg.isRecvMatching,
      isSenderMatching: me.msg.isSenderMatching,
      notificationType: me.msg.notificationType,
      storeMessageByTigase: me.msg.storeMessageByTigase,
      profilePhotoComment: me.msg.profilePhotoComment,
      expts: me.msg.expts,
      time: me.msg.time,
    };
    if (me.msg.type === 'cmd') {
      me.msg.body.action = me.msg.action;
    } else if (me.msg.type === 'loc') {
      me.msg.body.addr = me.msg.addr;
      me.msg.body.lat = me.msg.lat;
      me.msg.body.lng = me.msg.lng;
    } else if (me.msg.type === 'video') {
      me.msg.body = {
        ...me.msg.body,
        requestType: me.msg.requestType,
      };
    }
    //  console.log('debug@-message.send', me.msg);
    _send(me.msg);
  }
};

export { _Message as _msg, Message as message };
